import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import { View } from 'react-native';
import DataModel from 'root/libs/exaforte/react/DataModel';
import Config from 'root/globals/Config';
import { ContentDialog } from 'root/globals/Dialog';
import CustomForm from 'root/libs/exaforte/react/form/CustomForm';
import { ButtonGroup, Button } from 'root/globals/Elements';
import TouchableArea from 'root/libs/exaforte/react/TouchableArea';
import styles from 'root/globals/Defaults.less';

export default class SelectionDialog extends React.Component {
    constructor(props) {
        super();

        this.state      = {selection: {}};
        this.data_model = new DataModel(this, {name: 'selection'});
        this.save       = this.save.bind(this);

        this.data_model.set_fields(props.controller.component.state.action_fielddefines.selection);
    }
    
    save() {
        let models = this.props.controller.get_models_from_data({data: {models: (_.isArray(this.props.component) ? this.props.component : [this.props.component]), filter_field: {id: {value: this.props.controller.component.state.selected_ids, type: 'includes_desc'}}}, models: {return_models_split_components: false}});

        for(let field in this.state.selection)
        {
            for(let i in models)
                models[i].set_field_data({field: field, value: this.state.selection[field]});
        }
        
        this.props.controller.save({remove_models_after_save: true}).then(resp => {
            this.props.controller.component.setState({selected_ids: []});
            this.props.closeCallback();
        });
    }

    render() {
        let actions;
        
        if(this.props.closeCallback)
            actions = <ButtonGroup buttons={[{title: 'Sluiten', secondary: true, onPress: this.props.closeCallback, className: ['ml-2']}]} />;

        return <ContentDialog title={'Selectie aanpassen (' + _.size(this.props.controller.component.state.selected_ids) + ')'} description={'Kies hier welke velden je wilt aanpassen'} actions={actions} maxWidth={'sm'}>
            <CustomForm model={this.data_model} fielddefines={this.data_model.get_fields()} />
            <View className={['justify-content-end d-flex']}>
                <Button onPress={this.save} loading={this.props.controller.is_saving()}>Opslaan</Button>
            </View>
        </ContentDialog>;
    }
}